import { FC } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/Dialog/Dialog'
import { AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { CreateCompanyForm } from '@/features/Companies/CreateCompanyForm'
import { useTranslation } from 'react-i18next'

interface CreateCompanyModalProps {
  dialogProps: AlertDialogProps
  onCloseModal: () => void
}

export const CreateCompanyModal: FC<CreateCompanyModalProps> = props => {
  const { dialogProps, onCloseModal } = props
  const { t } = useTranslation(['company'])
  return (
    <Dialog {...dialogProps}>
      <DialogContent className={'overflow-y-auto max-h-[95vh]'}>
        <DialogHeader>
          <DialogTitle>{t('company:create_company_modal_title')}</DialogTitle>
          <CreateCompanyForm onCloseModal={onCloseModal} />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
